export const PERMISSION_GET_USERS_DICTIONARY = 'get-users-dictionary';
export const PERMISSION_CREATE_PARTNER_ADMIN = 'create-partner-admin';
export const PERMISSION_CREATE_USER = 'create-user';
export const PERMISSION_UPDATE_USER = 'update-user';
export const PERMISSION_DELETE_USER = 'delete-user';
export const PERMISSION_VIEW_USER = 'view-user';
export const PERMISSION_VIEW_USERS_LIST = 'view-users-list';
export const PERMISSION_VIEW_PARTNERS_LIST = 'view-partners-list';
export const PERMISSION_VIEW_PARTNER_USERS_LIST = 'view-partner-users-list';
export const PERMISSION_VIEW_STREAMING_REWARDS = 'view-streaming-rewards';
export const PERMISSION_VIEW_ROLES_LIST = 'view-roles-list';
export const PERMISSION_VIEW_SR_USERS = 'view-sr-users';
export const PERMISSION_VIEW_SR_OVERVIEW = 'view-streaming-reward-overview';
export const PERMISSION_VIEW_SR_INVITED_USERS = 'view-invited-streaming-reward-users';
export const PERMISSION_VIEW_SR_TRANSACTIONS_REPORTS = 'view-sr-transactions-reports';
export const PERMISSION_VIEW_MYBUNDLE_USERS = 'view-mybundle-users';
export const PERMISSION_MANAGE_PARTNER_SETTINGS = 'manage-partner-settings';
export const PERMISSION_LOGIN_AS_MYBUNDLE_USER = 'login-as-mybundle-user';
export const PERMISSION_MANAGE_SR_USERS = 'manage-streaming-reward-users';
